import { PendencyType } from '../enums/pendency-type.enum';
import { UtilHelper } from '../helpers/utils.helper';

export class Pendency {
  id: number;
  pendingType: PendencyType;
  status: 'PENDING' | 'OK';

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.pendingType != null && this.pendingType['code'] == null) {
      const pendency: PendencyType = UtilHelper.getEnumByCod(this.pendingType, PendencyType);
      if (pendency) {
        this.pendingType = pendency;
      }
    }
  }

  toUpdateJson(storeId: number, status: string): any {
    return {
      id: this.id,
      pendingType: this.pendingType['code'],
      status: status,
      storeId: storeId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/pendency.model.ts